import { Formik } from "formik"
import ErrorMessage from 'components/account/signup/Steps/ErrorMessage'
import React /*, {useEffect, useState}*/ from "react"
import { Link, useLocation } from "react-router-dom"
import { Alert } from "reactstrap"
import "./new_styles.scss"
import { apiAccount, signup as apiSignup } from "api"
import { useDispatch } from "react-redux"
import { nxAuthTokenAct } from "redux_new/actions"
import operatorActions from "redux/actions/user"
import { bindActionCreators } from "redux"
import { I18n } from "react-redux-i18n"
import { StepThree } from "components/account/signup/Steps"
import { useMediaQuery } from "react-responsive"
import Nixi1Spinner from "components/Nixi1Spinner"
import { getStaticImage } from "utils/statics"
import LandingLocale from "components/common/LandingLocale"

const Login = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const operatorActs = bindActionCreators(operatorActions, dispatch)
  const onNxAuthToken = bindActionCreators(nxAuthTokenAct, dispatch)

  const MAP_FIELD_ERRORS = {
    email: I18n.t("dashboard_errors_required-field"),
    password: I18n.t("dashboard_errors_required-field"),
  }

  const initialValues = {
    email: "",
    password: "",
  }

  const isMobile = useMediaQuery({
    query: "(max-width: 760px)",
  })

  const [errors, setErrors] = React.useState({})
  const [errorsResponse, setErrorsResponse] = React.useState({})
  const [loadingForm, setLoadingForm] = React.useState(false)
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [tokenRegister, setTokenRegister] = React.useState("")
  const [dataRegister, setDataRegister] = React.useState({})

  const submitFields = (values) => {
    const errors = {}
    if (!values.email) {
      errors.email = MAP_FIELD_ERRORS.email
    }

    if (!values.password) {
      errors.password = MAP_FIELD_ERRORS.password
    }

    if (Object.keys(errors).length === 0) {
      setErrors({})
      sendLogin(values)
    } else {
      setErrors(errors)
    }
  }

  const sendLogin = ({ email, password }) => {
    setLoadingForm(true)

    apiAccount
      .login({ email, password })
      .then(({ data, status }) => {
        if (status !== 200) throw data.error

        if (data.needVerify) {
          setTokenRegister(data.token)
          setDataRegister({ email })

          setShowConfirmModal(true)
        } else {
          onNxAuthToken.add(data.token)
          operatorActs.getOperator(data.token, false, location.search)
        }
      })
      .catch(({ response = {}, message }) => {
        const { data = {} } = response

        setErrorsResponse(data.message || message)
        setLoadingForm(false)

        if (data.url_to) window.location.assign(data.url_to)
      })
  }

  const changeEmail = (newEmail) => {
    const dataBody = {
      token: tokenRegister,
      oldEmail: dataRegister.email,
      newEmail: newEmail,
    }

    // request change email
    apiSignup
      .signupChangeEmail(dataBody)
      .then(({ data }) => {})
      .catch(({ data, status }) => {
        console.error("signupChangeEmail: error", data, status)
      })
  }

  const htmlForm = () => (
    <>
      {/* <div className="nfrl page-change-password-email">
        <div className="animated fadeIn">
          <div className="logo-container">
            <img src={getStaticImage(`/logo-white-v2.svg`)} alt="Logo" />
          </div>

          <Formik initialValues={initialValues} onSubmit={submitFields}>
            {({ values, handleChange, handleSubmit, isSubmitting }) => (
              <div className="page-container">
                <p className="form-title">{I18n.t("nfrl_login_title")}</p>
                <p className="form-subtitle">{I18n.t("nfrl_login_subtitle")}</p>

                {Object.keys(errorsResponse).length > 0 && (
                  <div className="signup-operator-alert-token">
                    <Alert color="danger">
                      {I18n.t("errors")[errorsResponse]}
                    </Alert>
                  </div>
                )}
                <div className="form-container">
                  <div className="personal-form">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      value={values.email}
                      placeholder={I18n.t("nfrl_login_input_email")}
                    />
                    {errors.email ? <ErrorMessage text={errors.email} /> : null}
                  </div>
                  <div className="personal-form">
                    <input
                    />
                    {errors.password ? (
                      <ErrorMessage text={errors.password} />
                    ) : null}
                  </div>
                  {btnSave(handleSubmit)}
                </div>
                <Link className="link-return" to="/change-password">
                  {I18n.t("nfrl_login_text_recover_password")}
                </Link>
              </div>
            )}
          </Formik>
        </div>
      </div> */}
      <div className="nixi_body">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-lg-4 col-md-6 left p-3">
              <div className="logo mt-2">
                <img src={getStaticImage(`/logo-white-v2.svg`)} alt="Logo" />
              </div>
              <div className="w-75">
                <h3 className="text-center mb-4">{I18n.t("dashboard_to-access")}</h3>
                <h4 className="text-center mb-4">{I18n.t("nfrl_login_subtitle")}</h4>
                <Formik initialValues={initialValues} onSubmit={submitFields}>
                  {({ values, handleChange, handleSubmit, isSubmitting }) => (
                    <>
                      <div className="input-div">
                        <label htmlFor="email" className="mb-2">
                          {I18n.t("nfrl_login_input_email")} <b className="red-star">*</b>
                        </label>
                        <input type="email" id="email" className="d-block w-100"
                          onChange={handleChange}
                          value={values.email}
                        />
                        {errors.email ? <ErrorMessage text={errors.email} /> : null}
                      </div>
                      <div className="input-div">
                        <label htmlFor="password" className="mb-2">
                          {I18n.t("dashboard_password")} <b className="red-star">*</b>
                        </label>
                        <input
                          type="password"
                          id="password"
                          className="d-block w-100 "
                          onChange={handleChange}
                          value={values.password}
                          onKeyDownCapture={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit()
                            }
                          }}
                        />
                        {errors.password ? (
                          <ErrorMessage text={errors.password} />
                        ) : null}
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        <Link
                          className="link ms-auto bg-transparent border-0 decoration-none"
                          to="/change-password"
                        >
                          {I18n.t('nfrl_login_text_recover_password')}
                        </Link>
                      </div>
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className="btn w-100 my-4 btn-yello"
                        disabled={loadingForm}
                      >
                        {loadingForm ? (
                          <Nixi1Spinner width={"1.5rem"} height={"1.5rem"} />
                        ) : (
                          I18n.t("button_login")
                        )}
                      </button>
                      {Object.keys(errorsResponse).length > 0 && (
                        <div className="signup-operator-alert-token">
                          <Alert color="danger">
                            {I18n.t("errors")[errorsResponse]}
                          </Alert>
                        </div>
                      )}
                    </>
                  )}
                </Formik>
              </div>
              <div className="bottom">
                <p className="text-center">
                  {new Date().getFullYear()} © Nixi1 Customer Services Solutions
                </p>
              </div>
            </div>
            <div className="col-lg-8 right col-md-6 overflow-hidden p-0">
              <img
                className="side-img img-fluid w-100 object-fit-cover"
                src={getStaticImage(`/banner-laptop-dashboard.png`)}
                alt="banner"
              />
            </div>
          </div>
        </div>
      </div>
      <LandingLocale
        direction='top'
      />
    </>
  )

  const htmlModalEmail = () => (
    <div className={!isMobile ? "signup" : "signup-mobile"}>
      <div className="animated fadeIn">
        <div className="logo-container">
          <img src={"/img/logo-white.svg"} alt="Logo" />
        </div>
        <div className="form-container-three">
          <div className="step-three-container">
            <StepThree changeEmail={changeEmail} dataRegister={dataRegister} />
          </div>
        </div>
      </div>
    </div>
  )

  if (!showConfirmModal) {
    return htmlForm()
  } else {
    return htmlModalEmail()
  }
}

export default Login
